
<div class="smash-logo">
    <i class="icon-smash_logo_no_chip"></i>
</div>
<div class="discover-container">
    <div class="discover-title" [innerHtml]="'MODAL_DISCOVER_PRO_TITLE' | translate | safeHtml"></div>
    <div class="card-container">        
        <div class="modal card left">
            <div class="header" translate>MODAL_DISCOVER_PRO_FREE_TITLE</div>
            <div class="body">
                <div class="section" [innerHtml]="'MODAL_DISCOVER_PRO_FREE_DESCRIPTION' | translate | safeHtml"></div>
            </div>
            <div class="footer">
                <button class="btn dark" (click)="goFreemium()" translate>MODAL_DISCOVER_PRO_FREE_BTN_LABEL</button>
            </div>
            <div class="illustration plane"></div>
        </div>
        <div class="modal card right">
            <div class="header" translate>MODAL_DISCOVER_PRO_PRO_TITLE</div>
            <div class="body">
                <div class="section" [innerHtml]="'MODAL_DISCOVER_PRO_PRO_DESCRIPTION' | translate | safeHtml"></div>
                <div class="section" *ngIf="priceFormatted; else loading" [innerHtml]="'MODAL_DISCOVER_PRO_PRO_DESCRIPTION_DYNAMIC_OFFER' | translate: { priceFormatted } | safeHtml"></div>
                <ng-template #loading>
                    <div class="section loading-spinner-container">
                        <div class="loading-spinner-grey"></div>
                    </div>
                </ng-template>
            </div>
            <div class="footer">
                <button class="btn red" (click)="goPro()" translate>MODAL_DISCOVER_PRO_PRO_BTN_LABEL</button>
            </div>
            <div class="illustration fuse"></div>
        </div>
    </div>
</div>


